import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class Price {
  public id: number;
  public price_de: string;
  public price_it: string;
  public price_en: string;
}

@Injectable({
  providedIn: 'root'
})
export class PricesService {
  private _price: Price = new Price();
  public priceSubject: Subject<Price> = new Subject();
  constructor(private _http: HttpClient) { }

  /**
   * getSchedulesOfOrganiaztion
   */
  public getSchedulesOfOrganiaztion(orgId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('orgId', orgId.toString());
    return this._http.get<Price>(environment.serverUrl + 'pricing/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        if (responseData.price_de) {
          responseData.price_de = responseData.price_de.replace(/<br\s*[\/]?>/gi, '\n');
        }
        if (responseData.price_it) {
          responseData.price_it = responseData.price_it.replace(/<br\s*[\/]?>/gi, '\n');
        }
        this._price = responseData;
        this.priceSubject.next(responseData);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  /**
   * updateSchedule
   */
  public updatePrices(price: Price, organizationId: string) {
    return this._http
      .post<Price>(
        environment.serverUrl + 'pricing/update',
        {
          'orgId': organizationId,
          'price_it': price.price_it,
          'price_de': price.price_de,
          'price_en': price.price_en
        }
      ).pipe(
        map(responseData => {
          this._price = responseData;
          this.priceSubject.next(responseData);
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }
}
